import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import store from "./store";
import history from "./services/history";
import App from "./App";

import "./assets/styles/main.scss";

ReactDOM.render(
  <React.StrictMode>
    <HistoryRouter history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </HistoryRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
